import RmnLeaderboardBanner from 'components/Rmn/RmnLeaderboardBanner/RmnLeaderboardBanner';
import { withRmnLeaderboardBannerProps } from 'viewModel/rmn/rmnLeaderboardBanner/withRmnLeaderboardBannerProps';

const ConnectedRmnLeaderboardBanner = withRmnLeaderboardBannerProps(RmnLeaderboardBanner);

export default ConnectedRmnLeaderboardBanner;
